import request from '@/utils/request'
export function getUmsAdminMessage() {
  return request({
    url:'/rechargeRecord/getUmsAdminMessage',
    method:'get'
  })
}

export function updateAccountBalance(data) {
  return request({
    url: '/rechargeRecord/updateAccountBalance',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/rechargeRecord.js